export default {
  pages: {
    key: "title",
    data: [
      {title: 'Home',   url: '/',      icon: 'HomeIcon', is_bookmarked: false},
      {title: 'Flohmärkte', url: '/events', icon: 'CalendarIcon', is_bookmarked: false},
      {title: 'Unbestätigte Reservierungen', url: '/reservations/pending', icon: 'GridIcon', is_bookmarked: false},
      {title: 'Bestätigte Reservierungen', url: '/reservations/approved', icon: 'GridIcon', is_bookmarked: false},
      {title: 'Home-Inhalte', url: '/contents', icon: 'EditIcon', is_bookmarked: false},
      {title: 'Kunden', url: '/customers', icon: 'UsersIcon', is_bookmarked: false},
      {title: 'Dashboard-Benutzer', url: '/admins', icon: 'UserCheckIcon', is_bookmarked: false},
      {title: 'Profile', url: '/profile', icon: 'UserIcon', is_bookmarked: false},
    ]
  }
}
